<template lang="pug">
	.widget-container(v-if="ready" :id="randomId")
		.sfc-best-529-plans-widget
			.info-container.side
				.blue-bar
				.row
					.col-sm-6.col-md-8.col-12.summary
						p Get smart about taxes
						h2 What is the tax benefit of a 529?
						p.light
							| Earnings in a 529 plan are federal tax exempt when withdrawn for use on qualified higher education expenses. This is what your federal tax savings could be if you save for 18 years.
						p.light.call-to-action
							|See the&nbsp;
							a.underline(href="/intro-to-529s/which-is-the-best-529-plan-available" @click="trackClickEvent()") best 529 plans of {{currentYear}}
					.col.white-bg-col.text-right.justify-content-center.flex-column.d-flex.col-sm-6.col-md-4.col-12
						.tax-container
							div.benefit.text-center
								span
									| {{formatting(this.federalTaxBenefit)}}
								span.ml-1
									sfc-tooltip-icon()
										.tooltip-content
											p
												| Assumptions:
											br
											p Based on federal tax rates for individuals who are married filing jointly with a household income of $100,000
											br
											p Assumes monthly contributions continue for 18 years and earn an annual rate of return of 7%
											br

							.slider-container
								div.slider
									sfc-slider(v-model="monthlyContribution" :min="25" :max="500" @callback="updateCalcs()" :tooltip="'hover'")
								.amounts
									span.left $25
									span.right $500
								div.slider-name
									| Monthly Contribution

</template>

<style lang="stylus">
@import './assets/css/general.styl';

</style>

<style lang="stylus" scoped>
@import './assets/css/variables.styl';

>>> .icon-info
	.hidden
	.open
		top: 1px
.info-container
	border: 1px solid #ced3e1
	.yellow-bar
	.red-bar
	.blue-bar
		height: 5px
		background: sfc-blue
		border: 1px solid sfc-blue-border
		position: absolute
		top: 0
		width: 100%
		left: 0
	.yellow-bar
		background: sfc-yellow
		border: 1px solid yellow-border
	.red-bar
		background: urgent-red
		border: 1px solid urgent-red
	&.side
		h3
			padding-left: 0px
			font-size: body-font-size-lg
		.yellow-bar
		.red-bar
		.blue-bar
			height: 100%
			width: 4px

.widget-container
	font-family "Rubik", sans-serif
	background-color: bg-gray
	border: 1px solid sfc-pale-gray
	box-shadow()
	overflow: hidden
	max-width: 800px
	margin: auto
	position: relative
	.underline
		text-decoration: underline
	.summary
		padding: 30px

	.tooltip-content
		text-align: left!important

	.sfc-best-529-plans-widget
		.benefit
			font-size: body-font-size-xl
			font-weight: body-font-weight-strong
			// line-height 56px
			color #000
			> span
				vertical-align: middle
				display: inline-block
				height: auto!important
		.slider-container
			margin-bottom: 0
			margin: 10px auto
			.slider
				left: 0!important
				padding-top: 0px
		.slider-name
			clear: both
			display: block
			text-align: center
			font-weight: body-font-weight
			margin-top: 15px
			font-size 15px
		.info-container
			padding: 0
			overflow: hidden
			> .row
				margin: 0
				> div
					padding: 30px

			.amounts
				margin-top: 5px
				> span
					font-weight: body-font-weight
					display: inline-block
					font-size 14px
					color #000
					&.left
						float: left
					&.right
						float: right
		.white-bg-col
			background: #fff
			border-left: 1px solid sfc-pale-gray
			padding: 15px!important
			@media (max-width: 567px)
				border-top: 1px solid sfc-pale-gray
				border-left: 0px
		a.btn
			float: right
			margin: 0
			margin-top: 7px
		p
			margin-bottom: 5px
			margin-top: 5px
			font-weight: body-font-weight
			color: body-font-color
			font-size: 14px
			line-height 28px
			&.call-to-action
				font-weight: body-font-weight
				margin-top: 10px
				margin-bottom: 0

		h2
			font-size 18px
			margin-top 20px
			margin-bottom: 0
			text-align: left!important
			font-weight bold
			line-height 27px
			@media (max-width: 768px)
				margin: 0!important



</style>


<script>
import https from 'https'
import axios from 'axios'
import {queryParams} from './query_params'
import {trackAnalyticsAction} from './track'
import Vue from 'vue'
import VueObserveVisibility from 'vue-observe-visibility'
import SfcTooltipIcon from './components/tooltip-icon'
import SfcSlider from './components/sfc-slider'
import Vue2Filters from 'vue2-filters'

Vue.use(Vue2Filters)

Vue.use(VueObserveVisibility)

export default {

	data(){
		return{
			ready: false,
			params: {},
			randomId: "theId",
			shownEventAlreadySent: false,
			currentYear: (new Date()).getFullYear(),
			monthlyContribution: 150,
			federalTaxBenefit: 0,
			sliderAlreadyTracked: false,
			show: false,
			widgetIdentifier: "",
		}
	},
	components: {
		SfcTooltipIcon,
		SfcSlider
	},

	methods: {

		formatting(number){
			if (number == 0){
				return "N/A"
			}
			return Vue.filter('currency')(number,'$',0)
		},

		async updateCalcs(fromSlider = true) {
			let taxFilingStatusText = "Married Filing Jointly"
			let stateId = "NY"
			let householdIncome = 100000
			this.taxData = await this.getTaxData(householdIncome, taxFilingStatusText, stateId)
			this.getProjected529()
			setTimeout(() => {
				this.sendHeight()
			}, 200)
		},

		async getTaxData(householdIncome, taxFilingStatus, stateId){
			return new Promise( async resolve => {
				const taxInfo = await this.getTaxJson()
				const allDeductionData = taxInfo["data"]["data"]["states_with_taxes"][stateId]["deductions"][taxFilingStatus]
				const allTaxData = taxInfo["data"]["data"]["states_with_taxes"][stateId]["taxes"][taxFilingStatus]

				const percentageForDeduction = allDeductionData["percentage_for_deduction"]
				const taxCreditAvailable = allDeductionData["maximum_credit"] != null && allDeductionData["maximum_credit"] > 0

				let maximumDeductible = allDeductionData["maximum_deductible_contribution"]
				if(taxCreditAvailable){
					maximumDeductible = allDeductionData["maximum_credit"]
				}

				const maximumDeduction = maximumDeductible * percentageForDeduction
				let stateTaxRate = 0

				for(let taxData of allTaxData){
					let minimum = taxData["minimum_tax_bracket"] || -1
					let maximum = taxData["maximum_tax_bracket"] || 999999999999
					if(minimum <= householdIncome && householdIncome <= maximum){
						stateTaxRate = taxData["tax_rate"]
						break
					}
				}

				const federalTaxData = taxInfo["data"]["data"]["federal_tax_rates"][taxFilingStatus]
				let federalTaxRate
				let  federalCapitalGains
				for(let taxData of federalTaxData){
					let minimum = taxData["minimum_tax_bracket"] || -1
					let maximum = taxData["maximum_tax_bracket"] || 999999999999
					if(minimum <= householdIncome && householdIncome <= maximum){
						federalTaxRate = taxData["tax_rate"]
						federalCapitalGains = taxData["marginal_capital_gain_rate"]
						break
					}
				}

				const taxDataToReturn = {
					federalInfo: {
						taxRate: federalTaxRate,
						capitalGainsFederal: federalCapitalGains
					},
					stateInfo: {
						taxRate: stateTaxRate || 0,
						maximumDeductible: maximumDeductible,
						maximumDeduction: maximumDeduction,
						percentageForDeduction: percentageForDeduction,
						taxCreditsAvailable: taxCreditAvailable
					}
				}
				resolve(
					taxDataToReturn
				)
			})
		},

		async getTaxJson(){
			let taxDataUrl = "https://web-resources.savingforcollege.com/data/tax_data.json"
			const taxResponse = await axios.get(taxDataUrl)
			return taxResponse
		},

		getProjected529(){
			let amount = 0
			try {
				const projector = new SfcPortfolioProjector({
					initial_payment: 0,
					recurrent_payment: this.monthlyContribution,
					yearly_rate_of_return_array: [7.0 / 100.0], // default value
					years: 18,
					tax_data: this.taxData
				});
				const calcs = projector.calculate()
				this.federalTaxBenefit = calcs.output.total_projection.federal_tax_benefit
				this.sendHeight()
			}
			catch(error){
				console.log("ERROR")
				console.log(error)

				amount = 0
			}
			return amount
		},

		sendHeight(left = 5) {
			let appDiv = document.getElementById(this.randomId)
			if (appDiv) {
				window.top.postMessage({widgetIdentifier: this.widgetIdentifier, height: appDiv.scrollHeight + 5}, "*")
				setTimeout(() => {
					window.top.postMessage({widgetIdentifier: this.widgetIdentifier, height: appDiv.scrollHeight + 5}, "*")
					if (left > 0) {
						this.sendHeight(left - 1)
					}
				}, 200)
			} else {
				setTimeout (() => {
					this.sendHeight()
				}, 100)
			}
		}
	},

	mounted(){
		this.params = queryParams()
		let randomNumber = Math.ceil(Math.random()*1000000)
		this.randomId = `sfc-external-ad-container-${randomNumber}`
		this.widgetIdentifier = this.params.widgetIdentifier
		this.updateCalcs(false)
		this.ready = true
	}
}
</script>

